import React from 'react';
import { Container, Typography, Grid, Box, Paper } from '@mui/material';
import Image from './Image';

// Import the imageConfig to test if our image imports are working
import { BANNERS, ABOUT, SERVICES, HOME } from '../assets/images/imageConfig';

// Don't use direct import, use paths from imageConfig
const testImagePath = SERVICES.SECURITY;

const ImageTest = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Image Loading Test
      </Typography>
      
      <Typography variant="h6" gutterBottom>
        Direct Image Path Test:
      </Typography>
      <Box 
        component="img" 
        src={testImagePath}
        alt="Direct path test" 
        sx={{ 
          width: '100%', 
          maxWidth: 400, 
          height: 'auto',
          mb: 4 
        }} 
      />

      <Typography variant="h6" gutterBottom>
        Images from Config:
      </Typography>
      
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={3}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="subtitle1">BANNERS.ABOUT</Typography>
            <Box sx={{ height: 200, overflow: 'hidden' }}>
              <Image src={BANNERS.ABOUT} alt="About Banner" />
            </Box>
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6} lg={3}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="subtitle1">SERVICES.SECURITY</Typography>
            <Box sx={{ height: 200, overflow: 'hidden' }}>
              <Image src={SERVICES.SECURITY} alt="Security Service" />
            </Box>
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6} lg={3}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="subtitle1">HOME.HERO</Typography>
            <Box sx={{ height: 200, overflow: 'hidden' }}>
              <Image src={HOME.HERO} alt="Home Hero" />
            </Box>
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6} lg={3}>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Typography variant="subtitle1">ABOUT.VISION</Typography>
            <Box sx={{ height: 200, overflow: 'hidden' }}>
              <Image src={ABOUT.VISION} alt="Vision" />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ImageTest; 